import { ReviewItem } from '@/types/api';
import { cn } from '@/utils/tailwind';
import moment from 'moment';

const AlreadyAnswered = ({ review }: { review: ReviewItem }) => {
  return (
    <div className={cn('flex h-full flex-col gap-[10px]')}>
      <div className="flex gap-2.5 text-gr-500 Caption1M12">
        <span>답글을 등록했어요</span>
        {moment(review.ReviewCommentList[0]?.comment_create_date).format('YY/MM/DD HH:mm')}
      </div>
      <div className="flex-1 text-gr-700 Body5M14">
        {review.ReviewCommentList[0]?.review_comment}
      </div>
    </div>
  );
};

export default AlreadyAnswered;
